import { Link } from 'react-router-dom';
import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';

const signs = [
  'Você tem currículo, posição, renda — mas sente que ainda não chegou onde quer.',
  'Já tentou coaching, terapia, cursos. Ajudou um pouco. Mas algo persiste.',
  'Você perfora vidros mas acorda exausta, sem saber bem por quê.',
  'Sabe inglês, já morou fora, se vira bem em qualquer ambiente — e ainda assim tem um bloqueio interno.',
  'Sua vida externa é invejável. Sua vida interna pede atenção.',
  'Você sente que poderia render muito mais — como líder, como mãe, como mulher.',
  'Você lê em dois idiomas, viaja business class e ainda fica travada na mesma crença de sempre.',
];

const profiles = [
  {
    icon: 'ri-briefcase-line',
    title: 'Executiva C-Level',
    desc: 'Diretora, VP ou C-suite que quer liderar com autoridade genuína e não só com o cargo.',
  },
  {
    icon: 'ri-building-line',
    title: 'Empresária',
    desc: 'Fundadora ou sócia que triplicou o faturamento — e agora precisa triplicar a mente.',
  },
  {
    icon: 'ri-stethoscope-line',
    title: 'Profissional Liberal',
    desc: 'Médica, advogada, arquiteta. Alta renda, alta responsabilidade, pouco espaço para si.',
  },
  {
    icon: 'ri-global-line',
    title: 'Executiva Internacional',
    desc: 'Trabalha em inglês, navega culturas, tem passaporte carimbado — e quer estar inteira.',
  },
];

export default function ParaQuemE() {
  return (
    <section className="py-28 px-6 bg-[#0d0d0d] relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/25 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/10 to-transparent"></div>

      <div className="max-w-6xl mx-auto relative z-10">
        {/* Header */}
        <ScrollRevealWrapper animation="fade-up">
          <div className="max-w-2xl mb-20">
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="h-px w-6 bg-gold-500/50"></div>
              <span className="text-gold-400 text-xs font-semibold tracking-[0.25em] uppercase font-['Montserrat']">
                Para quem é este método
              </span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-bold text-white leading-[1.05] mb-6">
              Você reconhece<br />
              <span className="text-gold-400">algum destes sinais?</span>
            </h2>
            <p className="text-white/50 text-lg font-light leading-relaxed font-['Montserrat']">
              Se mais de 3 dessas frases ressoam com você, o Método Bia Holmes foi feito exatamente para o momento que você está vivendo.
            </p>
          </div>
        </ScrollRevealWrapper>

        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Lista de sinais */}
          <ScrollRevealWrapper animation="fade-right">
            <div className="space-y-3">
              {signs.map((sign, i) => (
                <div
                  key={i}
                  className="group flex items-start gap-4 p-4 rounded-xl hover:bg-gold-500/5 transition-colors duration-200 border border-transparent hover:border-gold-500/10"
                >
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-gold-500/15 border border-gold-500/25 flex-shrink-0 mt-0.5 group-hover:bg-gold-500/25 transition-colors">
                    <i className="ri-check-line text-gold-400 text-xs"></i>
                  </div>
                  <p className="text-white/65 font-['Montserrat'] leading-relaxed text-sm">
                    {sign}
                  </p>
                </div>
              ))}

              <div className="mt-8 pl-4 border-l-2 border-gold-500/40">
                <p className="text-white/45 text-sm italic font-['Montserrat'] leading-relaxed">
                  "Não é fraqueza. É sinal de que você está pronta para o próximo nível — e que seu sistema interno ainda não acompanhou o externo."
                </p>
                <p className="text-gold-400 text-sm font-semibold mt-2 font-['Montserrat']">— Bia Holmes</p>
              </div>
            </div>
          </ScrollRevealWrapper>

          {/* Perfis */}
          <ScrollRevealWrapper animation="fade-left">
            <div>
              <p className="text-xs font-semibold text-white/30 tracking-[0.2em] uppercase mb-6 font-['Montserrat']">
                Quem costuma trabalhar com o método
              </p>
              <div className="space-y-3 mb-10">
                {profiles.map((p) => (
                  <div
                    key={p.title}
                    className="flex items-start gap-4 p-5 bg-[#111111] border border-gold-500/10 rounded-xl hover:border-gold-500/30 transition-all duration-200 group"
                  >
                    <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-gold-500/8 border border-gold-500/15 group-hover:border-gold-500/30 group-hover:bg-gold-500/15 transition-all flex-shrink-0">
                      <i className={`${p.icon} text-xl text-gold-400`}></i>
                    </div>
                    <div>
                      <h3 className="font-display text-base font-bold text-white mb-1">{p.title}</h3>
                      <p className="text-sm text-white/45 font-light font-['Montserrat'] leading-relaxed">{p.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-br from-[#1a1500] to-[#0a0a0a] rounded-2xl p-7 border border-gold-500/20">
                <p className="text-gold-400/60 text-xs tracking-widest uppercase font-['Montserrat'] mb-3">
                  Primeiro passo
                </p>
                <h3 className="font-display text-2xl font-bold text-white mb-3 leading-tight">
                  Descubra qual padrão<br />
                  <span className="text-gold-400">está te segurando.</span>
                </h3>
                <p className="text-white/45 text-sm font-light font-['Montserrat'] mb-6 leading-relaxed">
                  Diagnóstico gratuito de 5 minutos. Resultado personalizado com as técnicas de PNL exatas para o seu perfil.
                </p>
                <Link
                  to="/quiz"
                  className="inline-flex items-center gap-2 px-7 py-3.5 bg-gradient-to-r from-gold-500 to-gold-700 text-[#0a0a0a] rounded-full font-bold text-sm hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap font-['Montserrat'] tracking-wide"
                >
                  Fazer Diagnóstico Gratuito
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </ScrollRevealWrapper>
        </div>
      </div>
    </section>
  );
}
